import { render, staticRenderFns } from "./Tmplt.camera.vue?vue&type=template&id=6f3327f8&"
import script from "./Tmplt.camera.vue?vue&type=script&lang=ts&"
export * from "./Tmplt.camera.vue?vue&type=script&lang=ts&"
import style0 from "./Tmplt.camera.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports